<template>
  <div class="productDetails">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.ReportsDetail.Product_Details') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_1') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.front"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in productProcess.front"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_2') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.side"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in productProcess.side"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_3') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.back"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in productProcess.back"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_4') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.inside"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in productProcess.inside"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_5') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.printdetail"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in productProcess.printdetail"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_6') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.productsize"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in productProcess.productsize"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Batch_7') }}</span>
      <div class="img">
        <show-img
          :data="productProcess.contrastphoto"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in productProcess.productsize"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>

    <div class="desOfGoods-table">
      <a-table
        class="desOfGoods-table2"
        :columns="columns"
        :dataSource="data"
        bordered
        :pagination="false"
        rowKey="id"
      >
      </a-table>
      <a-table
        class="desOfGoods-table3"
        :columns="columns1"
        :dataSource="data1"
        bordered
        :scroll="{ y: 200 }"
        :pagination="false"
        rowKey="id"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
// const data = [
//   {
//     street: 12,
//     street7: 23112,
//     street1: 321,
//     street2: 312,
//     street3: 312,
//     street4: 312,
//     street5: 312,
//   },
// ];
// const data1 = [
//   {
//     street1: '配件1',
//     street2: '23*34*34',
//   },
//   {
//     street1: '配件2',
//     street2: '23*34*34',
//   },
//   {
//     street1: '配件3',
//     street2: '23*34*34',
//   },
//   {
//     street1: '配件4',
//     street2: '23*34*34',
//   },
//   {
//     street1: '配件5',
//     street2: '23*34*34',
//   },
// ];
import showImg from './showImg';
export default {
  data() {
    return {
      columns: [
        {
          title: this.$tc('lang.ReportsDetail.Main_Product_Size'),
          children: [
            {
              title: this.$tc('lang.ReportsDetail.productName'),
              dataIndex: 'productName',
              key: 'productName',
            },
            {
              title: this.$tc('lang.ReportsDetail.Length'),
              dataIndex: 'productLength',
              key: 'productLength',
            },
            {
              title: this.$tc('lang.ReportsDetail.Width'),
              dataIndex: 'productWidth',
              key: 'productWidth',
            },
            {
              title: this.$tc('lang.ReportsDetail.Height'),
              dataIndex: 'productHeight',
              key: 'productHeight',
            },
            {
              title: this.$tc('lang.ReportsDetail.Weight'),
              dataIndex: 'productWeight',
              key: 'productWeight',
            },
          ],
        },
      ],
      data: [],
      columns1: [
        {
          title: this.$tc('lang.ReportsDetail.Accessory'),
          dataIndex: 'partName',
          key: 'partName',
          width: '40%',
        },
        {
          title: this.$tc('lang.ReportsDetail.Size'),
          dataIndex: 'partRecord',
          key: 'partRecord',
          width: '60%',
        },
      ],
      data1: [],
    };
  },
  components: {
    showImg,
  },
  computed: {
    details: {
      get() {
        return JSON.parse(JSON.stringify(this.$store.state.report.details));
      },
    },
    productProcess: {
      get() {
        return this.$store.state.report.imgList.productProcess;
      },
    },
  },
  created() {
    this.getSelectDate();
  },
  methods: {
    getSelectDate() {
      this.$http
        .post('/hzwmj/inspect-mainproduct/selectDate', {
          orderNo: this.details.orderId,
          reportNo: this.details.ireportId,
        })
        .then(data => {
          if (data.data) {
            this.data = [data.data[0].mainproduct];
            this.data1 = data.data[0].parts;
          } else {
            this.data1 = [];
            this.data1 = [];
          }
        })
        .catch(() => {
          this.data = [];
          this.data1 = [];
        });
    },
  },
};
</script>
<style lang="less">
.productDetails {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    text-align: left;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table2 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .desOfGoods-table3 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
</style>
